import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUser } from "../../redux/slices/user.slice";
import { useLazyGetCustomerMeQuery } from "../../redux/services/auth";

const GoogleCallback = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [getCustomerMe] = useLazyGetCustomerMeQuery();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const access = params.get("access_token");
    const refresh = params.get("refresh_token");
    const profileStr = params.get("profile") || params.get("user") || null;

    if (access) {
      try {
        localStorage.setItem("access_token", access);
        if (refresh) localStorage.setItem("refresh_token", refresh);

        if (profileStr) {
          try {
            const p = JSON.parse(decodeURIComponent(profileStr));
            if (p) dispatch(setUser(p));
          } catch (e) {
            console.error("GoogleCallback: failed to parse profile param", e);
          }
        }

        // Fetch fresh profile to get verified_channels (not included in redirect params)
        getCustomerMe()
          .unwrap()
          .then((profile) => {
            if (profile) dispatch(setUser(profile));
          })
          .catch((e) => {
            console.error(
              "GoogleCallback: failed to fetch customer profile",
              e,
            );
          });
      } catch (e) {
        console.error("GoogleCallback token handling error", e);
      }
      // Redirect to main app
      navigate("/");
    } else {
      // No token - redirect to login
      navigate("/student/login");
    }
  }, [search, dispatch, navigate]);

  return null;
};

export default GoogleCallback;
